var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xj-basic-detail-page"},[_c('el-card',{staticClass:"box-form"},[_c('c-title',{attrs:{"slot":"header","title":'详情'},slot:"header"}),_c('student-info',{attrs:{"id":_vm.id,"familyFlag":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }